import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ArrangeIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M12 8.1a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm-8 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 10a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm-8 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 5a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm-8 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4-20a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm-8 0A1.1 1.1 0 108 .9a1.1 1.1 0 000 2.2zm4 10a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm-8 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
ArrangeIcon.isCarinaIcon = true;
export default ArrangeIcon;
